import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import Icon from "./Icon.js";
/**
 * A modal dialog: backdrop, a titled panel, a body and a footer. Escape and a backdrop click close
 * it.
 *
 * Walk 4 (#2268) adds three OPTIONAL props, each omitted by every earlier caller so their dialogs
 * are unchanged:
 *   • `description` — a line under the title (the look-through dialog's "X owns 25% or more…").
 *   • `closeLabel`  — draws a close (X) button in the head with this accessible name.
 *   • `className`   — an extra class on the panel, for layout only (a wider dialog). Never colour.
 *
 * Walk 4 review fix (PR #2273) adds `dismissible` (default true, so every earlier caller is
 * unchanged): false while the dialog's own work is in flight, so Escape, a backdrop click and the
 * close button do nothing — a save cannot be abandoned half-way by a stray click.
 */
export default function Modal({ open, onClose, title, children, footer, description, closeLabel, className, dismissible = true, }) {
    useEffect(() => {
        if (!open || !dismissible)
            return;
        function onKey(e) { if (e.key === "Escape")
            onClose(); }
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose, dismissible]);
    if (!open)
        return null;
    const dismiss = dismissible ? onClose : undefined;
    return (_jsx("div", { className: "modal-backdrop", onClick: dismiss, children: _jsxs("div", { className: className ? `modal ${className}` : "modal", onClick: (e) => e.stopPropagation(), role: "dialog", "aria-modal": "true", "aria-label": title, children: [_jsxs("div", { className: "modal__head", children: [_jsxs("div", { className: "modal__titles", children: [_jsx("h3", { className: "ard-h3", children: title }), description !== undefined && _jsx("p", { className: "modal__sub", children: description })] }), closeLabel !== undefined && (_jsx("button", { type: "button", className: "modal__close", "aria-label": closeLabel, onClick: dismiss, disabled: !dismissible, children: _jsx(Icon, { name: "x", size: 18, "aria-hidden": "true" }) }))] }), _jsx("div", { className: "modal__body", children: children }), _jsx("div", { className: "modal__foot", children: footer })] }) }));
}
//# sourceMappingURL=Modal.js.map